export interface OrderSummary {
  totalComplete: number;
  totalActive: number;
  totalReady: number;
  totalCancelled: number;
  totalUnsuccessful: number;
  signingFailedCount: number;
  optOutCount: number;
  vaultingFailedCount: number;
  inProgressCount: number;
  signingCount: number;
  sessionCompleteCount: number;
  vaultingCount: number;
}

export interface DateRange {
  startOfDay: Date;
  endOfDay: Date;
}

export function getDateRange(date: Date = new Date()): DateRange {
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);

  return { startOfDay, endOfDay };
}

export function calculateOrderSummary(orders: any[]): OrderSummary {
  const totalComplete = orders.filter(o => o.order.statusCode === 'COMPLETE').length;
  const totalReady = orders.filter(o => o.order.statusCode === 'READY').length;

  const inProgressCount = orders.filter(o => o.order.statusCode === 'INPROGRESS').length;
  const signingCount = orders.filter(o => o.order.statusCode === 'SIGNING').length;
  const sessionCompleteCount = orders.filter(o => o.order.statusCode === 'SESSIONCOMPLETE').length;
  const vaultingCount = orders.filter(o => o.order.statusCode === 'VAULTING').length;
  const totalActive = inProgressCount + signingCount + sessionCompleteCount + vaultingCount;

  const signingFailedCount = orders.filter(o => o.order.statusCode === 'SIGNINGFAILED').length;
  const optOutCount = orders.filter(o => o.order.statusCode === 'OPTOUT').length;
  const totalCancelled = orders.filter(o => o.order.statusCode === 'CANCELLED').length;
  const vaultingFailedCount = orders.filter(o => o.order.statusCode === 'VAULTINGFAILED').length;
  const totalUnsuccessful = signingFailedCount + optOutCount + vaultingFailedCount;

  return {
    totalComplete,
    totalActive,
    totalReady,
    totalCancelled,
    totalUnsuccessful,
    signingFailedCount,
    optOutCount,
    vaultingFailedCount,
    inProgressCount,
    signingCount,
    sessionCompleteCount,
    vaultingCount
  };
}
